import type { Damage } from "../../types/damage.types";
import type { DamageDto } from "@/lib/api/generated/fleet/models/damageDto";
import { cleanWebApiDateString } from "@/utils/date.utilities";

export function toDamage(dto: DamageDto): Damage {
	return {
		id: dto.id,
		vehicleId: dto.vehicleId,
		user: dto.user,
		vehicleUsageId: dto.vehicleUsageId,
		bookingId: dto.bookingId,
		imageUrls: dto.imageUrls,
		description: dto.description,
		creationDate: cleanWebApiDateString(dto.creationDate),
		status: dto.status,
		phase: dto.phase,
	};
}
